import { pushEvent } from "@wbly/common";
import type { DataLayer } from "@wbly/common";

export const trackClickBurgerMenu = (navigationType: string) =>
  pushEvent(
    window?.dataLayer as DataLayer[],
    navigationType,
    "click_mobile_nav_burger-menu",
    "nav_menu"
  );

export const trackMenuOpen = (
  navigationType: string,
  menuLabel: string,
  level: number,
  menuId?: string
) =>
  pushEvent(
    window?.dataLayer as DataLayer[],
    navigationType,
    `menu_open_level${level}`,
    menuLabel,
    menuId
  );

export const trackMenuItemSelect = (
  navigationType: string,
  menuItemLabel: string,
  url: string
) =>
  pushEvent(
    window?.dataLayer as DataLayer[],
    navigationType,
    "menu_item_select",
    menuItemLabel,
    url
  );
